import { render, staticRenderFns } from "./shutdowns_add.vue?vue&type=template&id=3db4abbc&"
import script from "./shutdowns_add.vue?vue&type=script&lang=ts&"
export * from "./shutdowns_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports